/** @format */
import { MarketCode } from '@mpb-com/feather/enums';

export const marketsWithTotalsExcludingTax = [MarketCode.EN_US];
export const marketsWithModernSlaveryStatement = [MarketCode.EN_UK];
